import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { browserHistory } from 'react-router';
import * as d3 from 'd3';
import styles from './../ComparisonEmbed/ComparisonEmbed.css';
import withStyles from '../../decorators/withStyles';
import ImpactsData from '../ImpactsData';
import Comparison from '../Comparison';
import ComparisonSelector from '../ComparisonSelector';
import PlaceRanking from '../PlaceRanking';

const ComparisonSlide = ({ impactPct, impactName, waterLevel, impact, data, place, placeName, protection, noData,
                           comparisonType, factCriteria, placeContainer, availableComparisons, placeRanking,
                           comparisonParent, ssid }) => {
  const totalOrPct = impactPct ? "Percentage of" : "Total";
  const contiglevees = protection === "protected" ? "tidelcontiglevees" : "tidelthresh";
  const setTxContent = (el) => d3.select(el).attr('tx-content', 'block');

  return (
    <div>
      <h1>
        <span ref={setTxContent}>{totalOrPct + ' ' + impactName.toLowerCase()}</span>
        <span>&nbsp;</span>
        <span>below</span>
        <var> {waterLevel.level} {waterLevel.unit} </var>
        <ComparisonSelector
          placeName={placeName}
          placeType={place.type}
          comparisonType={comparisonType}
          comparisonParent={comparisonParent}
          placeSSID={ssid}
          placeContainer={placeContainer}
          subRegions={availableComparisons}
          isEmbed={true}
        />
      </h1>
      <Comparison
        impact={impact}
        impacts={data.impacts}
        percentage={impactPct}
        placeType={place.type}
        placeID={place.id}
        placeName={placeName}
        waterLevel={waterLevel}
        protection={contiglevees}
        noData={noData}
        comparisonType={comparisonType}
        impactName={(impact in factCriteria && factCriteria[impact].name) ? factCriteria[impact].name : impactName}
        impactPosttransform={impact in factCriteria && factCriteria[impact].posttransform}
        impactPretransform={impact in factCriteria && factCriteria[impact].pretransform}
      />
      <PlaceRanking
        placeList={placeRanking}
        impactName={impact}
        impactPct={impactPct}
        handleClick={() => {}}
        impactPosttransform={impact in factCriteria && factCriteria[impact].posttransform}
      />
      <p className="map-explain" ref={setTxContent}>Values {protection === "protected" ? "exclude" : "include"} sub-<var>{waterLevel.level}{waterLevel.unit}</var> areas
        potentially protected by levees or other features. Elevation is defined relative to local high tide lines.
        Source: Climate Central Risk Finder, <var>{new Date().getFullYear()}</var>. <a className="novisit" href="http://www.riskfinder.org/">http://www.riskfinder.org/</a>
      </p>
      <div className="cc-logo-img"></div>
    </div>
  );
};


class ComparisonEmbed extends Component {

  render() {
    return (
      <div className="ComparisonEmbed band white">
        <section>
          <ImpactsData>
            <ComparisonSlide />
          </ImpactsData>
        </section>
      </div>
    )
  }
}

export default compose(
  withStyles(styles),
  connect((state) => state),
)(ComparisonEmbed);
